"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectedFilesSource;
(function (SelectedFilesSource) {
    SelectedFilesSource[SelectedFilesSource["LocalComputerFiles"] = 0] = "LocalComputerFiles";
    SelectedFilesSource[SelectedFilesSource["ProviderFiles"] = 1] = "ProviderFiles";
})(SelectedFilesSource = exports.SelectedFilesSource || (exports.SelectedFilesSource = {}));
//# sourceMappingURL=FilePickerResult.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/types/FilePickerResult.js
// module id = 1797
// module chunks = 2 3 43 106 107